/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ResetTokenTimeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('RESET_TOKEN_TIME')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class ResetTokenTimeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ResetTokenTimeSettingParser.decode(input).map(res => new ResetTokenTimeSetting(res));
    }
    static unsafeDecode(input) {
        return ResetTokenTimeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ResetTokenTimeSettingParser.encode(data);
    }
    static schema() {
        return ResetTokenTimeSettingParser.schema();
    }
}
